// @ts-ignore
import { CheckBox } from "react-native-web";
import { CheckBoxProps } from "@react-native-community/checkbox";

export const Checkbox: React.FC<CheckBoxProps & { color?: string }> = CheckBox;
